export enum Clients {
  surepayroll = 'sure',
  runpayroll = 'rp',
  paychex = 'pxgo',
  suntrust = 'sunt',
  truist = 'tru',
}
